import PromotionModal from '@basicComponents/sequential-modal/promotion-modal';
import React, {useCallback, useEffect} from 'react';
import {sequentialStorage} from '@utils/Storage/SequentialStorage';
import {useModalManager} from '@basicComponents/sequential-modal/ModalManagerProvider';
import HomeYue from './home-yue';
import {getReward} from '@/common-pages/luckyspin/luckyspin.service';
import globalStore from '@services/global.state';
import CheckInModal, {CHECK_IN_NAME} from '@basicComponents/check-in-modal';

const HOME_SEQUENTIAL = 'home-sequential';
const REWARD_TITLE = 'reward';
const rewardModalData = async () => {
  if (!globalStore.token) {
    return null;
  }
  const res = await getReward();
  if (res) {
    return {
      rewardAmount: res.rewardAmount,
      step: res.stage,
      title: REWARD_TITLE,
    };
  }
  return null;
};
const sequentialData = () => {
  return sequentialStorage.remindData;
};
export default function HomeSequential() {
  const {showModal, hideModal, currentModalId} = useModalManager();
  const sortPop = (data: any[]) => {
    return data.sort((a, b) => {
      const getPriority = (item: any) => {
        if (item.title === REWARD_TITLE) return 2;
        if (item.title === CHECK_IN_NAME) return 3;
        return 4;
      };
      return getPriority(a) - getPriority(b);
    });
  };
  const checkPop = (data: any[]) => {
    // 处理优先级，优先级转盘高
    if (data.length > 0) {
      showModal({
        id: HOME_SEQUENTIAL,
        modals: sortPop(data)
          .map(item => {
            if (item.title === REWARD_TITLE) {
              return <HomeYue step={item.step} reward={item.rewardAmount} />;
            }
            if (item.title === CHECK_IN_NAME) {
              if (globalStore.token) {
                return <CheckInModal key={item.bannerId} />;
              } else {
                return null;
              }
            }
            return (
              <PromotionModal
                key={item.bannerId}
                imageUrl={item.popImg}
                openUrl={item.popUrl}
              />
            );
          })
          .filter(Boolean),
      });
    }
  };
  const updatePops = useCallback(() => {
    let timer: NodeJS.Timeout | null = null;
    const fn = () => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        if (location.href.indexOf('/index/home') > -1) {
          Promise.allSettled([rewardModalData(), sequentialData()])
            .then(res => {
              const popList: any[] = [];
              const [rewardSettled, sequentialData] = res;
              if (rewardSettled.status === 'fulfilled' && rewardSettled.value) {
                popList.push(rewardSettled.value);
              }
              if (
                sequentialData.status === 'fulfilled' &&
                sequentialData.value
              ) {
                popList.push(...sequentialData.value);
              }

              return popList;
            })
            .then(data => {
              checkPop(data);
            });
        }
      }, 1000);
    };
    // 数据更新
    sequentialStorage.on('updated', fn);
    sequentialStorage.loadData();
    return () => {
      console.log('销毁');
      sequentialStorage.off('updated');
      if (currentModalId.current === HOME_SEQUENTIAL) {
        hideModal(HOME_SEQUENTIAL);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const off = updatePops();
    return off;
  }, [updatePops]);
  return null;
}
